// extracted by mini-css-extract-plugin
export default {"tabs":"universal-search-tabs_tabs__-MqQN","tab":"universal-search-tabs_tab__OaaGP"};